import { NavLink, Outlet } from 'react-router-dom'
import { PageHeader, PageLayout } from '@/widgets/layout/ui/AppLayout'
import { SetupMap } from '@/widgets/setup-map'
import { useProfile } from '@/entities/profile'
import { useWorkingHours } from '@/entities/working-hours'
import { BotBanner } from '@/entities/bot'
import styles from './ui/SettingsPage.module.css'

/**
 * Настройка агента: всё в одном месте, вкладками.
 *
 * Карта справа остаётся общей для всех вкладок — она и связывает их в
 * одно занятие: видно, что заполнено и куда идти дальше, не выходя из
 * раздела.
 */
export function SettingsPage() {
  const profile = useProfile()
  const hours = useWorkingHours()

  // Пустые разделы помечаются на самой вкладке: иначе про незаполненную
  // анкету узнают, только зайдя в неё.
  const tabs = [
    {
      to: '/settings/profile',
      label: 'Анкета',
      empty: !profile.data?.business.trim() || !profile.data?.offerings.trim(),
    },
    { to: '/settings/voice', label: 'Голос', empty: false },
    {
      to: '/settings/hours',
      label: 'Часы звонков',
      empty: !hours.data?.some((day) => !day.closed),
    },
    { to: '/settings/prompt', label: 'Промпт', empty: false },
    { to: '/settings/company', label: 'Компания', empty: false },
  ]

  return (
    <PageLayout aside={<SetupMap />}>
      <PageHeader title="Настройка агента" />
      <BotBanner />

      <nav className={styles.tabs}>
        {tabs.map((tab) => (
          <NavLink
            key={tab.to}
            to={tab.to}
            className={({ isActive }) => `${styles.tab} ${isActive ? styles.tabActive : ''}`}
          >
            {tab.label}
            {tab.empty && <span className={styles.mark} title="не заполнено" />}
          </NavLink>
        ))}
      </nav>

      <div className={styles.content}>
        <Outlet />
      </div>
    </PageLayout>
  )
}
